export const TwoColumn = () => (
  <svg width="80" height="37" viewBox="0 0 80 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.867188" width="79" height="35" rx="3.5" fill="white" />
    <path d="M8 8.36719H20.8544" stroke="#1B6DFC" strokeWidth="2" />
    <path d="M31.7754 8.36719H72.0007" stroke="#1B6DFC" />
    <path d="M31.7754 12.3672H72.0007" stroke="#1B6DFC" />
    <path d="M31.7754 16.3672H72.0007" stroke="#1B6DFC" />
    <path d="M31.7754 20.3672H72.0007" stroke="#1B6DFC" />
    <path d="M31.7754 24.3672H72.0007" stroke="#1B6DFC" />
    <path d="M31.7754 28.3672H72.0007" stroke="#1B6DFC" />
    <rect x="0.5" y="0.867188" width="79" height="35" rx="3.5" stroke="#1B6DFC" />
  </svg>
);
